import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Home from "../pages/Home";
import ProductUpload from "../pages/ProductUpload";
import Coupon from "../pages/Coupon";
import Inventory from "../pages/Inventory";
import Order from "../pages/Order";
import Product from "../pages/Product";
import Purchase from "../pages/Purchase";
import Login from "../pages/Login";
import ProtectedRoute from "../components/ProtectedRoute";
import BlogEditor from "../components/BlogEditor";
import Artist from "../pages/Artist";
import Cart from "../pages/Cart";
import AssignCoupon from "../pages/AssignCoupon";

const router = createBrowserRouter([
   {
    path: "/",
    element: <App/>,
    children: [
        {
            path: "",
            element: <ProtectedRoute><Home/></ProtectedRoute>
        },
        {
            path: "/login",
            element: <Login/>
        },
        {
            path: "/blog",
            element: <BlogEditor/>
        },
        {
            path: "product-upload", // This is the correct relative path
            element: <ProtectedRoute><ProductUpload /></ProtectedRoute>
        },
        {
            path: "coupons", // This is the correct relative path
            element: <ProtectedRoute><Coupon /></ProtectedRoute>
        }
        ,
        {
            path: "inventory", 
            element: <ProtectedRoute><Inventory /></ProtectedRoute>
        },
        {
            path: "order", 
            element: <ProtectedRoute><Order /></ProtectedRoute>
        },
        {
            path: "product", 
            element: <ProtectedRoute><Product /></ProtectedRoute>
        },{
            path: "purchase", 
            element: <ProtectedRoute><Purchase /></ProtectedRoute>
        },
        {
            path: "artist", 
            element: <ProtectedRoute><Artist /></ProtectedRoute>
        },
        {
            path: "cart", 
            element: <ProtectedRoute><Cart /></ProtectedRoute>
        },
        {
            path: "assign-coupon", 
            element: <ProtectedRoute><AssignCoupon /></ProtectedRoute>
        }
    ]
}
])
export default router